export default __webpack_public_path__ + "static/media/app-store.90bdb11b.svg";